import * as React from 'react';
export const zalopaySvg = React.forwardRef(function zalopaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.772 7.434a.891.891 0 0 0 .085-.938A.892.892 0 0 0 9.055 6H3.002v1.747h4.353l-4.153 5.537a.891.891 0 0 0-.085.938c.153.305.46.495.802.495h6.053V12.97H5.62l4.152-5.536Zm15.816 5.536a1.741 1.741 0 0 1 0-3.48 1.741 1.741 0 0 1 0 3.48Zm0-5.227a3.49 3.49 0 0 0-3.487 3.487 3.491 3.491 0 0 0 3.487 3.487 3.491 3.491 0 0 0 3.487-3.487 3.491 3.491 0 0 0-3.487-3.487Z',
      fill: '#0033C9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.487 22.564a1.741 1.741 0 0 1 0-3.481 1.741 1.741 0 0 1 0 3.481Zm0-5.228A3.491 3.491 0 0 0 3 20.823v6.1h1.746V23.84c.513.297 1.107.47 1.741.47a3.49 3.49 0 0 0 3.487-3.487 3.49 3.49 0 0 0-3.487-3.487Zm17.277.002-1.857 4.333-1.764-4.333h-1.886l2.682 6.59-1.283 2.994h1.9l4.108-9.584h-1.9Z',
      fill: '#00CF6A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.107 12.97a1.737 1.737 0 1 1 1.737-1.737c0 .96-.777 1.737-1.737 1.737Zm3.486 0V7.743h-1.749v.637a3.197 3.197 0 0 0-1.9-.629c-1.833 0-3.319 1.56-3.319 3.483s1.486 3.482 3.32 3.482a3.22 3.22 0 0 0 2.227-.905c.357.545.972.905 1.672.906h.618V12.97h-.87Z',
      fill: '#0033C9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.107 22.565a1.737 1.737 0 1 1 1.737-1.737c0 .96-.777 1.737-1.737 1.737Zm3.486 0v-5.228h-1.749v.637a3.197 3.197 0 0 0-1.9-.628c-1.833 0-3.319 1.559-3.319 3.482 0 1.923 1.486 3.482 3.32 3.482a3.22 3.22 0 0 0 2.227-.905c.357.545.972.906 1.672.906h.618v-1.747h-.87Z',
      fill: '#00CF6A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.874 12.969V6h-1.75v6.714c0 1.106.896 2.002 2.002 2.003h.624v-1.748h-.876Z',
      fill: '#0033C9',
    }),
  );
});
zalopaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var zalopay = {
  category: 'brand',
  colorable: false,
  name: 'zalopay',
  svg: zalopaySvg,
};
